import { render, staticRenderFns } from "./profileDashboard.vue?vue&type=template&id=c640d1dc&"
import script from "./profileDashboard.vue?vue&type=script&lang=js&"
export * from "./profileDashboard.vue?vue&type=script&lang=js&"
import style0 from "./profileDashboard.vue?vue&type=style&index=0&id=c640d1dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports